/**
 * KnowledgeMapDetailsDrawer Messages
 *
 * This contains all the text for the KnowledgeMapDetailsDrawer component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.knowledge.item.details';

export default defineMessages({
  humanCodingSchemeLabel: {
    id: `${scope}.humanCodingSchemeLabel`,
    defaultMessage: 'Short code',
  },
  humanCodingSchemePlaceholder: {
    id: `${scope}.humanCodingSchemePlaceholder`,
    defaultMessage: 'Type a short code',
  },
  titleLabel: {
    id: `${scope}.titleLabel`,
    defaultMessage: 'Title',
  },
  titlePlaceholder: {
    id: `${scope}.titlePlaceholder`,
    defaultMessage: 'Type a title',
  },
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'Type a full statement describing this knowledge item',
  },
  itemHasReplacement: {
    id: `${scope}.itemHasReplacement`,
    defaultMessage: 'Item has been replaced',
  },
  duplicateTitle: {
    id: `${scope}.duplicateTitle`,
    defaultMessage: 'Objective already exists.',
  },
  emptyTitle: {
    id: `${scope}.emptyTitle`,
    defaultMessage: 'This field is required.',
  },
  duplicateShortCode: {
    id: `${scope}.duplicateShortCode`,
    defaultMessage: 'This is a duplicated shortcode',
  },

  shortCodeLengthError: {
    id: `${scope}.shortCodeLengthError`,
    defaultMessage: 'Please enter a short code less than 32 characters',
  },
});
